import React from 'react'
import "./Rules.css"
const Rules = () => {
    return (
        <div className="game-rules">
            <h1>Let's play <b>Hangman</b></h1>
            <p>Hangman is a simple word guessing game. Players try to figure out an unknown word by guessing letters. 
            If too many letters which do not appear in the word are guessed, the player is hanged (and loses).</p>

            <p className="bold">Rules of the game are as follows</p>
            <ul>
                <li>- As letters in the word are guessed, the letter is revealed above the cooresponding underline. </li>
                <li>- If a letter not in the word is guessed, system starts drawing a picture of a person on the gallow – <i>one part for each incorrect letter guess.</i></li>
                <li>- 6 wrong guesses, and the player is hanged.</li>
            </ul>
        </div>
    )
}

export default Rules